module.exports = __webpack_public_path__ + "media/images/syntax/63-16af420b6ce8e355eae9e40b821a96a9.png";